<div class="flex flex-col h-auto">
  <div class="flex justify-between items-center m-4 border-b border-customBlueHard">
    <p class="text-general-title font-semibold color-blue">
      {{ this.data.Titule }}
    </p>

    @if (this.data.buttonClose) {
      <button
        (click)="closeModal()"
        class="flex! justify-center! items-center!"
        color="primary"
        mat-icon-button
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <div class="flex flex-col justify-betweenl">
    @if (data.text) {
      <div class="p-3 flex flex-col overflow-auto box-scrollv text-general text-center">
        {{ this.data.text }}
      </div>
    }

    @for (bodyList of data.bodyList; track $index) {
      <div class="p-3 flex flex-col overflow-auto box-scroll">
        @if (bodyList.tilte) {
          <div class="text-general-subtitle mb-5 text-center">
            {{ bodyList.tilte }}
          </div>
        }
        <div class="flex flex-col gap-2 text-general m-auto w-4/5">
          @for (text of bodyList.list; track $index) {
            <div class="flex gap-2 shrink-0 justify-center items-center">
              <div class="shrink-0 rounded-full size-2 bg-(--comp-button-bg-primary)!"></div>
              <div>
                {{ text }}
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (this.data.button) {
      <div class="flex justify-center py-4 w-full gap-4">
        <button
          mat-button
          class="w-45 h-13! rounded-xl text-white! bg-(--comp-button-bg-primary)!"
          (click)="newTableModal()"
        >
          {{ this.data.button }}
        </button>

        @if (this.data.buttonCancel) {
          <button
            mat-button
            class="w-45 h-13! rounded-xl text-white! bg-(--comp-button-bg-primary)!"
            (click)="cancelModal()"
          >
            {{ this.data.buttonCancel }}
          </button>
        }
      </div>
    }
  </div>
</div>
